import AttendApplicationListPage from './AttendApplicationListPage';

export default AttendApplicationListPage;
